import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { servicesApi as n } from "@maat/api-main";
//#region src/services/useServiceQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getService(r),
	enabled: !!r
});
//#endregion
export { r as useServiceQuery };
